import { render } from "./Export.vue?vue&type=template&id=3318cccd"
import script from "./Export.vue?vue&type=script&lang=js"
export * from "./Export.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__